import React from 'react'
import { styled } from '@mui/material'
import DoughnutChart from '../Charts/DonutChart/DoughnutChart'

const rejectionDataMapperUnit4 = (dataObj = {}) => {
  const chartData = []

  const flattenedData = Object.keys(dataObj).reduce((acc, partFamily) => {
    const value = dataObj[partFamily]

    if (typeof value === 'object' && !Array.isArray(value)) {
      Object.keys(value).forEach((reasonKey) => {
        const num = Number(value[reasonKey]) || 0
        acc[reasonKey] = (acc[reasonKey] || 0) + num
      })
    } else {
      const num = Number(value) || 0
      acc[partFamily] = (acc[partFamily] || 0) + num
    }

    return acc
  }, {})

  for (const property in flattenedData) {
    if (!Object.prototype.hasOwnProperty.call(flattenedData, property)) continue
    if (!property) continue
    const value = Number(flattenedData[property])
    if (!isNaN(value) && value > 0) {
      chartData.push({
        label: property,
        value: value
      })
    }
  }

  chartData.sort((a, b) => b.value - a.value)

  return {
    labels: chartData.map((el) => el.label),
    values: chartData.map((el) => el.value)
  }
}

const Container = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid lightgray',
  borderRadius: '12px'
}))

const CardHeader = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '12px',
  borderBottom: '1px solid lightgray'
}))

const CardBody = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '12px'
}))

const RejectionChartWithoutControls = ({
  rejectionData,
  selectionComponent
}) => {
  console.log('rejectionData', rejectionData)

  const chartData = rejectionDataMapperUnit4(rejectionData)

  const totalCount = chartData.values.reduce((acc, value) => acc + value, 0)

  return (
    <Container>
      <CardHeader>
        <h3>Rejection</h3>
        <h4>Total rejection = {Number(totalCount).toFixed(0)}</h4>
        {selectionComponent && (
          <div style={{ width: '300px' }}>{selectionComponent}</div>
        )}
      </CardHeader>
      <CardBody>
        <DoughnutChart
          chartTitle=""
          chartLabels={chartData.labels}
          dataGroup={chartData.values}
        />
      </CardBody>
    </Container>
  )
}

export default RejectionChartWithoutControls
